import { ref, onMounted, onBeforeUnmount } from 'vue';

export function useStickyHeader() {
    const headerStuck = ref(false);
    const containerRef = ref(null);
    const theadRef = ref(null);

    const detectPrint = () => {
        const mediaQueryList = window.matchMedia('print');
        return mediaQueryList.matches;
    };

    const stickHead = () => {
        if (detectPrint()) return;
        if (headerStuck.value) return;

        const thead = theadRef.value.cloneNode(true);
        const virtualHeaders = thead.querySelectorAll('td, th');

        let sum = 0;

        theadRef.value.querySelectorAll('td, th').forEach((actualTd, index) => {
            const width = document.defaultView.getComputedStyle(actualTd, '').width;

            sum += parseFloat(width);

            virtualHeaders[index].style.width = `${parseFloat(width) - 0.01}px`;

            // Hack: Removes the red/green border from highs/lows page
            virtualHeaders[index].classList.remove('border-b-2');
        });

        const trCount = thead.querySelectorAll('tr').length;

        sum /= trCount;

        thead.style.width = `${sum - 0.01}px`;

        thead.classList.add('stuck-header');
        thead.classList.add('print:hidden');

        thead.style.position = 'absolute';
        thead.style.top = '0';
        thead.style.backgroundColor = '#003468';
        thead.style.color = '#FFF';
        thead.style.zIndex = 6;

        containerRef.value.prepend(thead);

        headerStuck.value = true;
    };

    const resizeHeader = () => {
        if (detectPrint()) return;
        if (!headerStuck.value) return;
        if (!containerRef.value) return;

        const virtualHeaders = containerRef.value.querySelectorAll('.stuck-header > tr td, .stuck-header > tr th');

        let sum = 0;

        theadRef.value.querySelectorAll('td, th').forEach((actualTd, index) => {
            const width = document.defaultView.getComputedStyle(actualTd, '').width;

            sum += parseFloat(width);

            // hack: need to reduce the min-width... to prevent the FF 'div table overflow' issue
            virtualHeaders[index].style.minWidth = `${parseFloat(width) - 0.02}px`;
        });

        const trCount = containerRef.value.querySelectorAll('.stuck-header > tr').length;
        sum /= trCount;
        containerRef.value.querySelector('.stuck-header').style.width = `${sum - 0.01}px`;
    };

    const unstickHead = () => {
        if (headerStuck.value) {
            containerRef.value.querySelector('.stuck-header').remove();
            headerStuck.value = false;
        }
    };

    const handleTableScroll = () => {
        if (detectPrint()) return;
        resizeHeader();
    };

    const handleScroll = (e) => {
        if (detectPrint()) return;

        if (!theadRef.value) return;

        const tHeadDistanceFromTop = theadRef.value.getBoundingClientRect().top + window.scrollY;

        if (tHeadDistanceFromTop - window.scrollY < 0) {
            stickHead();

            const bodyTop = document.body.getBoundingClientRect().top;
            const elementTop = containerRef.value.getBoundingClientRect().top;
            const offset = elementTop - bodyTop;

            containerRef.value.querySelector('.stuck-header').style.transform = `translate(0, ${window.scrollY - offset}px)`;
            resizeHeader();
        } else {
            unstickHead();
        }
    };

    onMounted(() => {
        window.addEventListener('scroll', handleScroll);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('scroll', handleScroll);
    });

    return {
        headerStuck,
        containerRef,
        theadRef,
        handleTableScroll,
        resizeHeader,
    };
}
